'use strict';
var scrollAnimate = require('./scrollAnimate');
var constants = require('constants');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
            '<div class="email-signup-message ' + status + '"></div>'
        );
    }
    if ($('.sticky-add-to-cart').length > 0) {
        $('.email-signup-message').addClass('pdp-animate');
    } else {
        $('.email-signup-message').addClass('animate');
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 4000);
}

/**
 * This function handles the display of success/error message depending
 * on the result from submitting the sms signup form.
 * @param {boolean} isSuccess
 * @param {string} errorMessage
 */
function displaySmsSignupMessage(isSuccess, errorMessage) {
    $.spinner().stop();
    if (isSuccess) {
        $('.result-message-container .success-message').removeClass('d-none')
        $('#sms-signup-form').addClass('d-none')
    } else {
        if (errorMessage && errorMessage.length > 0) {
            $('.result-message-container .error-message').text(errorMessage)
        }
        $('.result-message-container .error-message').removeClass('d-none')
        $('#sms-signup-form').addClass('d-none')
    }
}

/**
 * This function intercepts the subscription signup form submission and computes
 * additional form data that is required for submission tracking on the backend. Once
 * the additional data is computed, the form is submitted via ajax.
 * @param {Element} emailInputElement
 * @param {Element} phoneInputElement
 * @param {Element} submitButtonElement
 * @param {string} submitUrl
 * @param {string} optInSource
 * @param {boolean} isSmsSignup
 * @param {string} csrfTokenValue
 */
function handleSubscriptionSignupSubmission(
    emailInputElement,
    phoneInputElement,
    submitButtonElement,
    submitUrl,
    optInSource,
    isSmsSignup,
    csrfTokenValue
) {
    $.spinner().start();
    submitButtonElement.attr('disabled', true);

    const data = {
        emailId: emailInputElement.val(),
        phoneNumber: phoneInputElement.val(),
        csrf_token: csrfTokenValue
    }

    if (isSmsSignup && $('#add-to-email-list').length > 0) {
        data.addToEmailList = $('#add-to-email-list').attr('checked') === 'checked';
    }

    if (isSmsSignup) {
        data.checkUserExistence = true;
    }

    if (optInSource) {
        data.optinSource = optInSource
    }

    $.ajax({
        url: submitUrl,
        type: 'post',
        dataType: 'json',
        data: data,
        success: function (responseData) {
            if (isSmsSignup && responseData.success) {
                displaySmsSignupMessage(true);
            } else {
                if (responseData.success) {
                    emailInputElement.val('');
                    phoneInputElement.val('');
                }
                displayMessage(responseData, submitButtonElement, isSmsSignup);
            }

            if (responseData.success) {
                document.body.dispatchEvent(new CustomEvent(constants.BRAZE.EVENTS.subscribed, {
                    detail: {
                        email: data.emailId
                    }
                }));
            }
        },
        error: function (err) {
            if (isSmsSignup) {
                const errorMessage = err.responseJSON && err.responseJSON.msg ? err.responseJSON.msg : null
                displaySmsSignupMessage(false, errorMessage);
            } else {
                displayMessage(err, submitButtonElement, isSmsSignup);
            }
        }
    });
}

/**
 * This function prepopulates the email address input for the SMS signup form
 * only if a customerEmail is provided via query param. If one is provided,
 * we check the add to email checkbox and hide it.
 */
function handlePrepopulationOfEmailAddress() {
    const params = Object.fromEntries(
        new URLSearchParams(window.location.search)
    )

    if (params.customerEmail && $('#sms-signup-email').length > 0) {
        $('#sms-signup-email').val(params.customerEmail);
    }

    if (params.customerEmail && $('#add-to-email-list').length > 0) {
        $('#add-to-email-list').prop('checked', true);
        const $addToEmailCheckboxFormGroup = $('#add-to-email-list').parent();
        $addToEmailCheckboxFormGroup.hide();
    }
}

module.exports = function () {
    $(document).ready(()=>{
        const processInclude = require('base/util');
        processInclude(require('dynamicYield/components/footer'));

        if ($('#sms-signup-form').length > 0) {
            handlePrepopulationOfEmailAddress();
        }
    });

    $('.back-to-top').click(function () {
        scrollAnimate();
    });

    // The footer signup form is in content and we can't generate a unique csrf
    // token from that asset so we'll fallback to the one we added to the window
    // that gets updated per request.
    const $csrfToken = $('input[name="csrf_token"]')
    let csrfTokenValue = ''
    if ($csrfToken.length > 0) {
        csrfTokenValue = $csrfToken.val()
    } else {
        csrfTokenValue = window.reactSystemData.csrf.token
    }

    const $form = $('#footer-subscription-signup');
    $form.on('submit', function (e) {
        e.preventDefault();
        if (!$form[0].checkValidity()) {
            return;
        }

        var $button = $('.subscribe-email');
        var url = $button.data('href');
        var emailId = $('input[name=hpEmailSignUp]');
        var phoneNumber = $('input[name=hpSMSSignUp]');
        handleSubscriptionSignupSubmission(
            emailId,
            phoneNumber,
            $button,
            url,
            null,
            false,
            csrfTokenValue
        );
    });

    const $smsSignupForm = $('#sms-signup-form')
    $smsSignupForm.on('submit', (e) => {
        e.preventDefault();
        const url = $smsSignupForm.attr('action');
        const $phoneInputElement = $('#sms-signup-phone');
        const $emailInputElement = $('#sms-signup-email');
        const $optInSource = $('#sms-optin-source').val();
        const $submitButton = $('#sms-signup-submit');

        handleSubscriptionSignupSubmission(
            $emailInputElement,
            $phoneInputElement,
            $submitButton,
            url,
            $optInSource,
            true,
            csrfTokenValue
        );
    })

    $('#sms-signup-email').change(() => {
        if ($('#add-to-email-list').attr('checked') === 'checked') {
            $('#add-to-email-list').attr('checked', false);
        }
        const $addToEmailCheckboxFormGroup = $('#add-to-email-list').parent();
        $addToEmailCheckboxFormGroup.show();
    })
};
